import React from 'react';
import { Link, Skeleton, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ClientNameAndAvatar } from '@/components/table/ClientNameAndAvatar';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { paths } from '@/app/routes';
import { getNameInitials } from '@/utils/constants';

export const DataGridAuditClientName = ({ clientId }) => {
	const theme = useTheme();
	const { data: clientRow, isLoading } = useGetClientRowQuery(clientId, {
		skip: !clientId,
	});

	if (!clientId) {
		return (
			<Typography variant='body2' color='text.secondary'>
				—
			</Typography>
		);
	}

	if (isLoading) {
		return <Skeleton variant='text' width='8em' />;
	}

	const clientLink = `${paths.clients}/${clientId}`;
	const name = clientRow?.name ?? clientId;

	return (
		<Link
			to={clientLink}
			component={RouterLink}
			underline='hover'
			sx={{ textDecorationLine: 'none', width: '100%' }}
		>
			<ClientNameAndAvatar
				title={name}
				initials={getNameInitials(name)}
				width={250}
				colour={theme.palette.primary.main}
				titleSx={{
					fontWeight: 600,
					'&:hover': {
						textDecoration: 'underline',
					},
				}}
			/>
		</Link>
	);
};
